<template>
  <div uk-height-viewport="expand: true">
    <div class="uk-overlay-primary uk-position-cover"></div>
    <div class="uk-position-center">
      <div class="uk-width-large uk-card uk-card-default uk-padding uk-border-rounded">
        <div data-uk-grid class="uk-grid">
          <div class="uk-width-1-1 uk-flex-center">
            <div class="uk-width-large uk-margin-auto">
              <h3 class="uk-heading-line text-red font-200 uk-text-center">
                <span>Passwort vergessen</span>
              </h3>
            </div>
            <div class="uk-width-1-1 uk-flex-center">
              <div class="uk-width-large uk-margin-auto">
                <div class="uk-alert-danger uk-alert" v-if="error || tokenInvalid">
                  Es ist ein Fehler aufgetreten! <br />Der Passwort Link ist ungültig!
                </div>

                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                  <form v-if="!tokenInvalid">
                    <fieldset class="uk-fieldset">
                      <div class="uk-margin">
                        <label class="uk-form-label">E-Mail*</label>
                        <ValidationProvider :rules="'required'" name="password" v-slot="{ errors }">
                          <input
                            type="text"
                            class="uk-input"
                            v-model="email"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>

                      <div class="uk-margin">
                        <label class="uk-form-label">Neues Passwort (min. 8 Zeichen)*</label>
                        <div class="uk-form-controls">
                          <ValidationProvider :rules="'min:8'" name="password" v-slot="{ errors }">
                            <input
                              class="uk-input"
                              type="password"
                              name="password"
                              v-model="password"
                              :class="{ 'uk-form-danger': errors[0] }"
                            />
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="uk-margin">
                        <label class="uk-form-label">Wiederholung neues Passwort*</label>
                        <div class="uk-form-controls">
                          <ValidationProvider
                            :rules="'required|min:8|confirmed:password'"
                            name="password_confirmation"
                            v-slot="{ errors }"
                          >
                            <input
                              class="uk-input"
                              type="password"
                              name="password_confirmation"
                              v-model="passwordConfirmation"
                              :class="{ 'uk-form-danger': errors[0] }"
                            />
                            <span v-if="errors[0]">Passwörter stimmen nicht überein</span>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="uk-margin">
                        <div class="uk-flex uk-flex-center">
                          <button
                            class="uk-button uk-button-primary uk-border-rounded uk-text-uppercase"
                            @click.prevent="handleSubmit(onSubmit)"
                            :disabled="sending"
                          >
                            Passwort ändern
                          </button>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, confirmed, min } from 'vee-validate/dist/rules'
import UserService from '@/services/user.service.js'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

extend('confirmed', {
  ...confirmed,
  message: 'Passwörter stimmen nicht überein'
})

extend('min', {
  ...min
})
export default {
  data() {
    return {
      error: false,
      tokenInvalid: false,
      password: '',
      passwordConfirmation: '',
      email: '',
      sending: false
    }
  },
  mounted() {
    //this.$store.commit('SET_LAYOUT', 'login-layout')
    this.checkToken(this.$route.query.token)
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    async onSubmit() {
      this.sending = true
      try {
        await UserService.changePassword(this.$route.query.token, {
          email: this.email,
          password: this.password
        })
        this.sending = false
        iziToast.success({
          title: 'OK',
          message: 'Passwort wurde geändert! Sie werden weitergeleitet...!',
          timeout: 4000,
          close: false,
          position: 'topCenter'
        })
        this.password = ''
        this.passwordConfirmation = ''
        this.email = ''
        setTimeout(() => {
          this.$router.replace({ name: 'Login' })
        }, 4000)
      } catch (error) {
        this.sending = false
        this.error = true
      }
    },
    async checkToken(token) {
      try {
        await UserService.checkToken(token)
        return
      } catch (error) {
        this.tokenInvalid = true
      }
    }
  }
}
</script>
